import { gql } from 'graphql-request';

export const INVOICE_UPDATE_AV_INVOICE_BILLING_INFO_CONTACT_EMAIL = gql`
  mutation InvoiceUpdateAvInvoiceBillingInfoContactEmail(
    $uuid: ID!
    $contactEmail: String!
  ) {
    invoiceUpdateAvInvoiceBillingInfoContactEmail(
      input: { uuid: $uuid, contactEmail: $contactEmail }
    ) {
      appVersion
      errors {
        fullMessages
      }
      record {
        id
        uuid
      }
      recordId
      recordUuid
      status
    }
  }
`;
